<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="opt-modal u-window">           
            <div class="dialog-content">
                <!-- <div class="u-btn close" @click="closeModal"></div> -->
                <div class="dialog-wrapper">
                    <div class="title"></div>
                    <div class="slogen">红包/礼包，2选1</div>
                    <div class="opt-view">
                        <div class="opt-view__swiper">
                            <swiper :options="swiperOptions" ref="interSwiper">
                                <swiper-slide v-for="(item,index) in gacha_list" :key="index">
                                    <div class="opt-view__pannel flex-center-center">
                                        <div class="opt-item">
                                            <div class="rb" :class="'rb-' + item.sendNum"></div>
                                            <div class="rb-name item-name">{{ item.sendNum }}元红包</div>
                                            <div class="u-btn check" @click="add_cart( item.orderId , index)">
                                                <div class="status checked" v-if="check_status(item.orderId , index)"></div>
                                            </div>
                                        </div>
                                        <div class="opt-item">
                                            <div class="cost-notice">
                                                <p>
                                                    周年庆超值礼包
                                                </p>                                              
                                            </div>
                                            <div class="game-item">
                                                <div class="icon-wrapper">
                                                    <div class="reward-pic" v-tips="cost_config[item.sendNum].giftId"><game-item :locked="true" :id="cost_config[item.sendNum].giftId" :num="1"></game-item></div>
                                                </div>
                                            </div>
                                            <div class="item-name">{{ cost_config[item.sendNum].name }}</div>
                                            <div class="u-btn check" @click="add_cart( 'game-item' + index , index)">
                                                <div class="status checked" v-if="check_status('game-item' + index , index)"></div>
                                            </div>
                                        </div>
                                    </div>
                                </swiper-slide>
                            </swiper>
                        </div>

                        <div class="u-btn prev"></div>
                        <div class="u-btn next"></div>
                    </div>

                    <div class="notice"><em class="icon sprite sprite-warn_modal"></em>选择红包需填写对应支付宝；提交后不可更改，不做补发；超过1小时未提交，将以默认红包形式发放，请及时确认！</div>

                    <div class="u-btn submit" @click="submit()"></div>

                    <div class="warn" v-if="!check_list()">你还有未选择并勾选的红包，请选择后再提交</div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>

.opt-modal{
    width: 690px;
    height: 653px;
    background-image: url(~@/assets/images/modal/bg-modal-opt.png);  
}

.title{
    width: 100%;
    height: 49px;
    margin: 0 auto 30px;
    background-repeat : no-repeat;
    background-position : center;
    background-image: url(~@/assets/images/modal/title-opt.png);     
}

.slogen{
    width: 610px;
    height: 40px;
    line-height: 40px;
    margin: 0 auto 40px;
    text-align: center;
    color: #f2d47a;
    background-image: url(~@/assets/images/modal/slogen-opt.png); 
}


.u-btn.submit{
    position: relative;
    width: 254px;
    height: 83px;
    margin: 15px auto 0;
    background-image: url(~@/assets/images/modal/btn-submit_opt.png);
    z-index: 10;
}

.notice{
    margin-top: -120px;
    padding: 0 50px;
    font-size: 20px;
    color: #ffb864;

    em{
        display: inline-block;
        vertical-align: middle;
        margin-right: 5px;
    }

}

.warn{
    margin-top: 16px;
    text-align: center;
    color: #ffe8a2;
}

.opt-view{
    margin-top: -150px;
    position: relative;
    &__swiper{
        height: 500px;
        .opt-item{
            position: relative;
            width: 182px;
            height: 225px;
            background-color: #4c0c08;
            margin: 0 20px;
            padding-top: 25px;
            box-sizing: border-box;

            &.active{
                border: 4px solid #955234;
            }
        }
    }

    .u-btn.prev{
        position: absolute;
        top: 220px;
        left: 40px;
        width: 42px;
        height: 40px;
        background-image: url(~@/assets/images/modal/btn-prev.png);
        z-index: 10;
    }

    .u-btn.next{
        position: absolute;
        top: 220px;
        right: 40px;
        width: 42px;
        height: 40px;
        background-image: url(~@/assets/images/modal/btn-next.png); 
        z-index: 10;
    }    

    .rb{
        margin: 0 auto;
    }

    .cost-notice{
        position: absolute;
        top: -85px;
        right: -80px;
        width: 157px;
        height: 117px;
        padding-top: 25px;
        box-sizing: border-box;
        font-size: 20px;
        color: #f8e1dc;
        background-image: url(~@/assets/images/modal/bg-bubble.png);

        b{
            color: #f2d47a;

            &.num{
                font-size: 26px;
            }
        }

        p{
            padding: 2px 15px 0;
        }
    }

    .item-name{
        margin-top: 12px;
        text-align: center;
        color: #fee1ae;
        font-size: 20px;
    }

    .u-btn.check{
        position: relative;
        width: 47px;
        height: 45px;
        margin: 12px auto 0;
        background-image: url(~@/assets/images/modal/bg-check.png);

        .checked{
            position: absolute;
            left: 10px;
            top: 0;
            width: 36px;
            height: 36px;
            background-image: url(~@/assets/images/modal/icon-check.png);
        }
    }

    .icon-wrapper{
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 84px;
        height: 84px;
        margin: 0 auto 0;
        background-image: url(~@/assets/images/modal/bg-item.png);

        .reward-pic{
            width: 68px;
            height: 68px;
        }
    }

}

</style>



<script>
import { apiOptGift } from '@/api/index.js'

export default {
    data () {
        return {
            visible : false,
            text : '',
            type : 'notice',
            cart : [],
            cost_config : {
                5 : {
                    giftId : 'QE31',
                    cost : 40,
                    name : '匠心青铜宝箱'
                },
                10 : {
                    giftId : 'QE32',
                    cost : 60,
                    name : '匠心白银宝箱'
                },
                20 : {
                    giftId : 'QE33',
                    cost : 100,
                    name : '匠心黄金宝箱'
                },
                50 : {
                    giftId : 'QE34',
                    cost : 200,
                    name : '匠心铂金宝箱'
                },
                100 : {
                    giftId : 'QE35',
                    cost : 400,
                    name : '匠心钻石宝箱'
                },
                1000 : {
                    giftId : 'QE36',
                    cost : 4000,
                    name : '追忆年少宝箱（7天）'
                },
                10000 : {
                    giftId : 'QE36',
                    cost : 29999,
                    name : '追忆年少宝箱（7天）'
                },                                                                                               
            },
            gacha_list : [],
            swiperOptions : {
                pagination: {
                    el: '.swiper-pagination',    //与slot="pagination"处 class 一致
                    clickable: true,            //轮播按钮支持点击
                },
                navigation: {
                    nextEl: ".next",
                    prevEl: ".prev",
                    disabledClass: "disabled",
                },                               
            }
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
        this.$disableScroll();
    },
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$enableScroll();
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },           
        closeModal(){
            this.destroyElement()
        },
        add_cart(orderId , index){
            const item = this.cart.find(i => i.pos == index);

            if(item){
                item.id == orderId ? this.cart[index].id = -1 : this.cart[index].id = orderId;                
            }
            else{
                this.cart.push({ id : orderId , pos : index , orderId : this.gacha_list[index].orderId })
            }
        },
        check_status(orderId , index){
            return this.cart.find(i => i.id == orderId && i.pos == index);
        },
        check_list(){
            return this.cart.filter(i => i.id != -1).length == this.gacha_list.length;
        },
        submit(){
            if(!this.check_list())return this.$toast('你还有未选择并勾选的红包，请选择后再提交');

            const ret = this.cart.filter( i => isNaN(parseInt(i.id))  && i.orderId ).map( i => i.orderId )

            if(!ret.length){
                this.destroyElement();

                if(((this.$store.state.userinfo.uflag & 256) != 256)){
                    this.$toast('兑换成功')
                    this.$ali_modal();
                }
                else{
                    this.$msg_modal({ text : '兑换成功' });
                }

                return;            
            }

            apiOptGift({ orderId : ret }).then(
                res => {
                    this.destroyElement();
                    
                    if(((this.$store.state.userinfo.uflag & 256) != 256) && ret.length < this.gacha_list.length){
                        this.$toast('兑换成功')
                        this.$ali_modal();
                    }
                    else{
                        this.$msg_modal({ text : '兑换成功' });
                    }
                },
                rej => {
                    this.$toast(rej.message)
                }
            )
        },
    },    
}
</script>